import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Fragment } from 'react/jsx-runtime';
import { useStoreSelector } from 'v3/data/store';
import {
  setCancelationErrorModalOpen,
  setCurrentCancellationState,
} from 'v3/data/store/cancellationNavigation/actions';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';
import {
  cancellationSteps,
  CONFIRM_CANCELLATION_INDEX,
  REQUEST_CANCELLATION_INDEX,
} from 'v3/pages/OnlineContracting/Cancellation/constants';
import { Container, InputContainer } from 'v3/pages/OnlineContracting/Cancellation/Steps/ReasonCancellationStep/styles';
import { CancellationReasonFormType } from 'v3/pages/OnlineContracting/Cancellation/Steps/ReasonCancellationStep/types';
import { AlignButtons } from 'v3/pages/OnlineContracting/Cancellation/styles';
import * as onlineApi from 'v3/services/online/api';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { HorizontalStepper } from 'v3/shared/components/HorizontalStepper';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { cancellationReasonSchema } from 'v3/shared/schemas/cancellationReason';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { theme } from 'v3/styles/global-styles';

export const ReasonCancellationStep = () => {
  const onlineContractingState = useStoreSelector((store) => store.onlineContracting);
  const { contractingKey } = useStoreSelector((store) => store.onlineContracting);

  const {
    control,
    getValues,
    formState: { isValid },
  } = useForm<CancellationReasonFormType>({
    resolver: yupResolver(cancellationReasonSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const onConfirmCancellation = async () => {
    try {
      await onlineApi.confirmCancellation(contractingKey, {
        reason: getValues('cancellationReason'),
        vtexOrderId: onlineContractingState.paymentDetails.orderId,
        vtexPaymentId: onlineContractingState.paymentDetails.paymentId,
      });
      setCurrentCancellationState(CancellationNavigationEnum.PROCESSING_CANCELLATION);
    } catch (error) {
      console.error('Error confirming cancellation:', error);
      setCancelationErrorModalOpen(true);
    }
  };

  return (
    <Fragment>
      <HorizontalStepper
        completedStepIndex={REQUEST_CANCELLATION_INDEX}
        activeStepIndex={CONFIRM_CANCELLATION_INDEX}
        steps={cancellationSteps}
      />

      <Container>
        <SubtitleMedium color={theme.palette.secondary.light}>Informe o motivo do cancelamento</SubtitleMedium>
        <InputContainer>
          <InputFormController
            data-testid="input-cancellation-reason"
            inputType="text"
            formControlName="cancellationReason"
            label="Motivo"
            formControl={control}
            fullWidth
          />
        </InputContainer>
        <AlignButtons>
          <TextButton
            text="Voltar"
            $outline
            size="small"
            fullWidth
            handleClick={() => {
              setCurrentCancellationState(CancellationNavigationEnum.CANCELLATION_STARTED);
            }}
          />
          <FlexButton
            disabled={!isValid}
            text="Sim, quero confirmar"
            size="small"
            fullWidth
            handleClick={onConfirmCancellation}
          />
        </AlignButtons>
      </Container>
    </Fragment>
  );
};
